/**
 * Expand and collapse menu items in mini-sitemaps
 */

const $j = jQuery.noConflict();

$j(() => {
  $j('.expandor').on('click', function handleExpandorClick() {
    // get the id of the element clicked
    //
    const expandorId = $j(this).attr('id');

    // get the parent id - the number at the end is
    //
    const childContainerClass = `children-of-${expandorId.substr(1 + expandorId.lastIndexOf('-'))}`;

    // are the children of the parent_id expanded or collapsed
    //
    if ($j(`.${childContainerClass}`).attr('class').indexOf('expanded') !== -1) {
      // expanded
      //
      // change the children ul class to collapsed
      //
      // $j('#' + childContainerClass).removeClass('collapsed');
      $j(`.${childContainerClass}`).removeClass('expanded');
      $j(`.${childContainerClass}`).addClass('collapsed');

      // [-] to [+]
      //
      $j(`#${expandorId}`).html('[+]');
    } else {
      // collapsed
      //
      // change the children ul class to expanded
      //
      $j(`.${childContainerClass}`).removeClass('collapsed');
      // $j('#' + childContainerClass).removeClass('expanded');
      $j(`.${childContainerClass}`).addClass('expanded');

      // [-] to [+]
      //
      $j(`#${expandorId}`).html('[&ndash;]');
    }
  });
});
